module.exports = __webpack_public_path__ + "static/media/TECHNOBIT 18 (282).49597447.JPG";